// extracted by mini-css-extract-plugin
export var gif = "_dy-0";